import _ from "lodash";
import {
  FETCH_UTTERANCE_CLUSTER_DATA,
  FETCH_UTTERANCE_DATA,
  FETCH_ANSWERS_FOR_UTTERANCE,
  SAVE_UTTERANCE_QUESTION_MATCH,
  SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH,
  SAVE_ENTITY_TYPE,
  FETCH_DROPDOWN_ENTITIES,
  FETCH_DROPDOWN_INTENTS
} from "./types";
import { API } from "aws-amplify";
import SQS from "aws-sdk/clients/sqs";
import Amplify from "aws-amplify";
import axios from "axios";
import { responsiveFontSizes } from "@material-ui/core";
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const fetch = require("node-fetch");

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

var getDaysArray = function(start, end, completeHistory) {
  if (completeHistory) return "audit-*";
  for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    arr.push("audit-" + new Date(dt).toISOString().split("T")[0]);
  }
  return _.join(arr, ",");
};

export const fetchUtteranceClusterData = param => async (dispatch, getState) => {
  const state = getState();
  let dates = getDaysArray(param.fromDate, param.toDate, param.completeHistory);
  
  let historySwitch = param.completeHistory;
  let numOfClusters = param.groupBy==="intent"?0:param.numOfClusters;
  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetUtteranceClusterData",
      dates: dates,
      start_date: param.fromDate.format("Y-MM-DD"),
      end_date: param.toDate.format("Y-MM-DD"),
      completeHistory: historySwitch,
      tenant: param.tenant,
      num_clusters: numOfClusters,
      time: new Date().getTime(), // we have this because we want to prevent caching
      ...apiRequestFixedParams
    }
  };
  var res = {};

  var errorResponse = {
    code: 500,
    data: [],
    chatbotId: null
  };
  var jobId = "";
  try {
    const response = await API.get(config.AWS_API_NAME, "es", data);

    if (response.code == 200 && response.jobId) {
      res["code"] = response.code;
      res["chatbotId"] = response.chatbot;
      res["count"] = response.count;
      res["data"] = [];
      jobId = response.jobId;
    }else{
      res=response;
    }

    if (jobId) {
      let data = await loadData(jobId);
      if (data === null) {
        res = errorResponse;
      } else {
        res["data"] = data;
      }
    }
  } catch (err) {
    res = res;
  }

  dispatch({
    type: FETCH_UTTERANCE_CLUSTER_DATA,
    payload: res
  });
};

export const fetchUtteranceData = param => async (dispatch, getState) => {

  const state = getState();

  let dates = getDaysArray(param.fromDate, param.toDate, param.completeHistory);
  let historySwitch = param.completeHistory;
  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetUtteranceData",
      dates: dates,
      tenant: param.tenant,
      start_date: param.fromDate.format("Y-MM-DD"),
      end_date: param.toDate.format("Y-MM-DD"),
      completeHistory: historySwitch,
      from: param.from,
      limit: param.limit,
      order: param.order ? "desc" : "asc",
      time: new Date().getTime(), // we have this because we want to prevent caching
      ...apiRequestFixedParams
    }
  };
  var res = {};
  try {
    const response = await API.get(config.AWS_API_NAME, "es", data);
    res["code"] = response.code;
    if (response.code == 200) {
      response.data.forEach(function(entry) {
        entry.OriginalQuestion = entry.MatchedQuestion;
      });
      res["data"] = response.data;
      res["chatbotId"] = response.chatbot;
      res["total"] = response.total;
    }
  } catch (err) {
    res["code"] = 500;
    res["data"] = [];
    res["chatbotId"] = null;
    res["total"] = 0;
  }
  dispatch({
    type: FETCH_UTTERANCE_DATA,
    payload: res
  });
};


export const fetchDropdownIntents = tenant => async(dispatch, getState) => {
  const state = getState();

  let data = {
    queryStringParameters: {
      tenant: tenant
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
    },
  };

  var res = {};
  const response = await API.get(config.AWS_API_NAME, "intents/list", data);
  
  res = response.intents;
  
  dispatch({
    type: FETCH_DROPDOWN_INTENTS,
    payload: res
  });
}

export const fetchDropdownEntities = tenant => async(dispatch, getState) => {
  const state = getState();

  let data = {
    queryStringParameters: {
      tenant: tenant
    },
    headers: {
      Authorization: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      "Content-Type": "application/json"
    },
  };

  var res = []; 
  let output= [];
  const response = await API.get(config.AWS_API_NAME, "intents/entity-types", data);

  if(response.entityTypes){
    res = [...response.entityTypes];
    res.forEach(function(item) {
      var existing = output.filter(function(v, i) {
        return v.name == item.name;
      });
      if (existing.length) {
        var existingIndex = output.indexOf(existing[0]);
        output[existingIndex].role = output[existingIndex].role.concat(item.role);
      } else {
        if (typeof item.role == 'string')
          item.role= [item.role];
        output.push(item);
      }
    });}
  
  dispatch({
    type: FETCH_DROPDOWN_ENTITIES,
    payload: output
  });
}

export const saveEntityType = (entity, role, tenant) => async(dispatch, getState) => {
  const state = getState();

  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      tenant: tenant,
      name: entity.name,
      role: role,
      ...apiRequestFixedParams
    }
  };

  const response = await API.post(config.AWS_API_NAME, "intents/entity-types", data);

  var res = {};
  if (response.status === "ok") {
    res = response.data;
  }

  dispatch({
    type: SAVE_ENTITY_TYPE,
    payload: res
  });

}

export const fetchAnswersForUtteranceData = param => async (dispatch, getState) => {

  const state = getState();
  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetAnswersForUtterancesList",
      chatbot_id: param.chatbotId,
      utterances: param.data,
      time: new Date().getTime(), // we have this because we want to prevent caching
      ...apiRequestFixedParams
    }
  };

  const response = await API.post(config.AWS_API_NAME, "es", data);

  var res = {};
  if (response.code == 200) {
    res = response.data;
  }

  dispatch({
    type: FETCH_ANSWERS_FOR_UTTERANCE,
    payload: res
  });
};

export const saveFeedback = (params, ids, values) => async (dispatch, getState) => {
  const state = getState();

  const response = await axios.post(config.AWS_API_URL_PUBLIC + "feedback", {
    ApiCall: "SaveFeedback",
    Items: params
  });
  // fix above for calling non existing env api gw endpoints located on development ot future public api gw endpoints
  /*   const response = await API.post(config.AWS_API_NAME_PUBLIC, "feedback", data); */
  var res = false;
  if (response.status == 200) {
    res = true;
  }

  //mark utterace data trained
  if (ids && res) {
    let dates = getDaysArray(values.fromDate, values.toDate, values.completeHistory);

    let markData = {
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "MarkUtteranceDataTrained",
        dates: dates,
        utterance_ids: ids,
        ...apiRequestFixedParams
      }
    };

    const response = await API.post(config.AWS_API_NAME, "es", markData);
    var res = false;
    if (response.code == 200) {
      res = true;
    }
  }

  dispatch({
    type: SAVE_UTTERANCE_QUESTION_MATCH,
    payload: res
  });
};

export const saveClusterFeedback = (feedback, values, utterances) => async (dispatch, getState) => {
  const state = getState();
  // first save feedback
  let data = {
    body: {
      ApiCall: "SaveFeedback",
      Items: feedback
    }
  };

  const response = await API.post(config.AWS_API_NAME, "feedback", data);

  var res = false;
  if (response.code === 200) {
    res = true;
  }

  //mark utterace data trained
  if (res) {
    let dates = getDaysArray(values.fromDate, values.toDate, values.completeHistory);

    let markData = {
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "MarkUtteranceClusterDataTrained",
        dates: dates,
        utterances: utterances,
        ...apiRequestFixedParams
      }
    };
    const response = await API.post(config.AWS_API_NAME, "es", markData);

    var res = false;
    if (response.code == 200) {
      res = true;
    }
  }
  dispatch({
    type: SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH,
    payload: res
  });
};

export const resetFeedbackSaveStatus = () => async (dispatch, getState) => {
  dispatch({
    type: SAVE_UTTERANCE_QUESTION_MATCH,
    payload: null
  });
};

function loadData(jobId) {

  return new Promise(resolve => {
    Amplify.Auth.currentCredentials().then(credentials => {
      var auth = Amplify.Auth.essentialCredentials(credentials);
      const sqs = new SQS({
        apiVersion: "2012-11-05",
        credentials: auth
      });

      const params = {
        QueueUrl: config.SQS_UTTERANCE_CLUSTER_DATA,
        MaxNumberOfMessages: 10,
        WaitTimeSeconds: 20,
        MessageAttributeNames: ["JobId"]
      };

      var poolMeesage = function(mS) {
        setTimeout(function() {
          sqs.receiveMessage(params, function(err, data) {
            if (err) {
              resolve(null);
            }
            for (let msg of data.Messages) {
              let msgBody = JSON.parse(msg.Body);
              if (msg.MessageAttributes.JobId.StringValue === jobId) {
                var deleteParams = {
                  QueueUrl: config.SQS_UTTERANCE_CLUSTER_DATA,
                  ReceiptHandle: msg.ReceiptHandle
                };
                sqs.deleteMessage(deleteParams, function(err, data) {
                  if (err) console.log(err, err.stack); // an error occurred
                });
                let URL = msgBody.result_uri;
                const response = fetch(URL, {
                  method: "Get"
                }).then(function(res) {
                  resolve(res.json());
                });
              } else {
                return poolMeesage(1000);
              }
            }
          });
        }, mS);
      };
      return poolMeesage(3000);
    });
  });
}
